<template>
  <div v-loading.fullscreen.lock="true" element-loading-text="钉钉登录中"></div>
</template>

<script>
export default {
  props: {
    companyId: {
      type: String,
      default: ''
    }
  },
  async mounted() {
    try {
      const { code, state } = this.$route.query
      await this.$store.dispatch('auth/ddlogin', {
        authCode: code,
        state,
        companyId: this.companyId
      })
      this.$router.push({ name: this.redirectToName || 'home' })
    } catch (e){
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>

</style>
